var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "analytics-area" }, [
    _c("h1", [_vm._v("\n    " + _vm._s(_vm.$t("analytics.header")) + "\n  ")]),
    _vm._v(" "),
    _c("div", { staticClass: "search-area" }, [
      _c(
        "div",
        { staticClass: "search-input" },
        [
          _c("Search"),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filter.search,
                expression: "filter.search",
              },
            ],
            attrs: {
              type: "text",
              сlass: "input",
              placeholder: _vm.$t("common.search") + "...",
            },
            domProps: { value: _vm.filter.search },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filter, "search", $event.target.value)
              },
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "charts" }, [
      _c("div", { staticClass: "chart" }, [
        _c("div", { staticClass: "header" }, [
          _c("p", [
            _vm._v(
              "\n          BNB " +
                _vm._s(_vm.$t("analytics.price")) +
                ": $" +
                _vm._s(_vm.bnbPrice) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("analytics.transactions")) +
                " (24" +
                _vm._s(_vm.$t("common.h")) +
                "):\n          "
            ),
            !_vm.countLoading
              ? _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$getBigNumber(_vm.countTransactions)) +
                      "\n          "
                  ),
                ])
              : _c(
                  "span",
                  [
                    _c("Skeleton", {
                      attrs: { width: "30px", height: "14px" },
                    }),
                  ],
                  1
                ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "chart-box" }, [
          _c("div", { staticClass: "header" }, [
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("analytics.liquidity")) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("\n            $0 +0%\n          ")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-container" },
            [
              _c("LineChart", {
                attrs: {
                  "chart-data": _vm.lineChart.data,
                  options: _vm.lineChart.options,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "chart" }, [
        _c("div", { staticClass: "header" }, [
          _c("p", [
            _vm._v(
              "\n          BNB " +
                _vm._s(_vm.$t("analytics.price")) +
                ": $" +
                _vm._s(_vm.bnbPrice) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("analytics.transactions")) +
                " (24" +
                _vm._s(_vm.$t("common.h")) +
                "):\n          "
            ),
            !_vm.countLoading
              ? _c("span", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$getBigNumber(_vm.countTransactions)) +
                      "\n          "
                  ),
                ])
              : _c(
                  "span",
                  [
                    _c("Skeleton", {
                      attrs: { width: "30px", height: "14px" },
                    }),
                  ],
                  1
                ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "chart-box" }, [
          _c("div", { staticClass: "header" }, [
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("analytics.liquidity")) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("\n            $0 +0%\n          ")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-container" },
            [
              _c("BarChart", {
                attrs: {
                  "chart-data": _vm.barChart.data,
                  options: _vm.barChart.options,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "top-table tokens" },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("analytics.top_tokens")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "mini-button",
                  attrs: { to: _vm.localePath("/analytics/tokens") },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("analytics.see_all")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("TopTokens"),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "top-table pairs" },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("analytics.top_pairs")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "mini-button",
                  attrs: { to: _vm.localePath("/analytics/pairs") },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("analytics.see_all")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("TopPairs"),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "top-table transactions" },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "h2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("analytics.transactions")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "mini-button",
                  attrs: { to: _vm.localePath("/analytics/transactions") },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("analytics.see_all")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("TopTransactions"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }